import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'
import { switchMap, take } from 'rxjs'
import { AuthService } from '@features/auth/auth.service'
import { addAuthorizationHeader } from '@features/http/util/add-authorization-header'

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('/auth')) {
    return next(request)
  }

  const auth = inject(AuthService)

  return auth.token$
    .pipe(
      take(1),
      switchMap(token => {
        if (!token) {
          return next(request)
        }

        return next(addAuthorizationHeader(request, token))
      }),
    )
}
